import { Checkbox } from "components/Atoms/inputs/Checkbox";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  readonly?: boolean
  permissions: server.dto.FreeFieldProfileWithPermission[]
  onChange: (permissions: server.dto.FreeFieldProfileWithPermission[]) => void
}

const FreeFieldPermissions = (props: Props) => {
  const onViewCheck = async (profile: server.dto.FreeFieldProfileWithPermission) => {
    let newProfile: server.dto.FreeFieldProfileWithPermission;
    if (profile.level === "hidden") {
      newProfile = { ...profile, level: "view" };
    } else {
      newProfile = { ...profile, level: "hidden" };
    }
    assignPermissions(newProfile);
  };

  const onViewModifyCheck = (profile: server.dto.FreeFieldProfileWithPermission) => {
    let newProfile: server.dto.FreeFieldProfileWithPermission;
    if (profile.level === "viewModify") {
      newProfile = { ...profile, level: "view" };
    } else {
      newProfile = { ...profile, level: "viewModify" };
    }

    assignPermissions(newProfile);
  };

  const onAcccessCheck = (profile: server.dto.FreeFieldProfileWithPermission) => {
    let newProfile: server.dto.FreeFieldProfileWithPermission;
    if (profile.level === "viewModify") {
      newProfile = { ...profile, level: "hidden" };
    } else {
      newProfile = { ...profile, level: "viewModify" };
    }

    assignPermissions(newProfile);
  };

  const assignPermissions = (newProfile: server.dto.FreeFieldProfileWithPermission) => {
    const index = props.permissions.findIndex(p => p.freeFieldProfileId === newProfile.freeFieldProfileId);
    const newPerms = Object.assign([], props.permissions, { [index]: newProfile });
    props.onChange(newPerms);
  };

  const internalPerms = props.permissions.filter(p => p.environment === "internal");
  const externalPerms = props.permissions.filter(p => p.environment === "external");

  const allInternalViewsChecked = internalPerms.every(perm => perm.level !== "hidden");
  const allInternalViewModifyChecked = internalPerms.every(perm => perm.level === "viewModify");

  const allExternalViewHasAccess = externalPerms.every(perm => perm.level === "viewModify");

  const setAll = (level: server.dto.FreeFieldPermissionLevels, environment: server.dto.Environments) => {
    let newLevel = level;

    if (environment === "internal") {
      if (level === "view" && allInternalViewsChecked) {
        newLevel = "hidden";
      }
      if (level === "viewModify" && allInternalViewModifyChecked) {
        newLevel = "view";
      }
    } else {
      if (level === "viewModify" && allExternalViewHasAccess) {
        newLevel = "hidden";
      }
    }

    const newPermissions = props.permissions.map(perm => ({ ...perm, level: perm.environment === environment ? newLevel : perm.level }));
    props.onChange(newPermissions);
  };

  return <div className="free-field-permissions-grid">
    <div className="free-field-permissions-grid-header">
      {RESX.UserType.InternalUsers}
    </div>
    <div className="free-field-permissions-grid-header">
      {props.readonly ? RESX.GeneralLabels.Visible :
        <Checkbox
          onChange={() => setAll("view", "internal")}
          checked={allInternalViewsChecked}
          label={RESX.GeneralLabels.Visible}
        />}
    </div>
    <div className="free-field-permissions-grid-header">
      {props.readonly ? RESX.SoUser.Modify :
        <Checkbox
          onChange={() => setAll("viewModify", "internal")}
          checked={allInternalViewModifyChecked}
          label={RESX.SoUser.Modify}
        />}
    </div>

    {props.permissions.filter(p => p.environment === "internal").map(profile => <React.Fragment key={profile.freeFieldProfileId}>
      <div>
        <a href={routes.freeFieldProfile_Detail("internal", profile.freeFieldProfileId).absolute}>{profile.title}</a>
      </div>
      {props.readonly ? renderViewChecked(profile.level) :
        <Checkbox
          onChange={() => onViewCheck(profile)}
          checked={profile.level === "view" || profile.level === "viewModify"}
          label={RESX.GeneralLabels.Visible}
        />}
      {props.readonly ? renderViewModifyChecked(profile.level) :
        <Checkbox
          onChange={() => onViewModifyCheck(profile)}
          checked={profile.level === "viewModify"}
          label={RESX.SoUser.Modify}
        />}
    </React.Fragment>)}

    <div className="free-field-permissions-grid-header">
      {RESX.UserType.ExternalUsers}
    </div>
    <div className="free-field-permissions-grid-header" />
    <div className="free-field-permissions-grid-header">
      {props.readonly ? RESX.SoUser.Modify :
        <Checkbox
          onChange={() => setAll("viewModify", "external")}
          checked={allExternalViewHasAccess}
          label={RESX.SoUser.Access}
        />}
    </div>

    {props.permissions.filter(p => p.environment === "external").map(profile => <React.Fragment key={profile.freeFieldProfileId}>
      <div>
        <a href={routes.freeFieldProfile_Detail("external", profile.freeFieldProfileId).absolute}>{profile.title}</a>
      </div>
      <div />
      {props.readonly ? renderViewModifyChecked(profile.level) :
        <Checkbox
          onChange={() => onAcccessCheck(profile)}
          checked={profile.level === "viewModify"}
          label={RESX.SoUser.Access}
        />}
    </React.Fragment>)}
  </div>
};

const renderViewChecked = (level: server.dto.FreeFieldPermissionLevels) => {
  if (level === "view" || level === "viewModify") {
    return <i className="icon-check green" />
  }

  return <i className="icon-x red" />
}

const renderViewModifyChecked = (level: server.dto.FreeFieldPermissionLevels) => {
  if (level === "viewModify") {
    return <i className="icon-check green" />
  }

  return <i className="icon-x red" />
}

export default FreeFieldPermissions;
